module.exports = __webpack_public_path__ + "static/media/sweets.50f78ed1.svg";